<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div
        class="d-flex justify-content-between align-items-center mb-3 header"
      >
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Membership Listing
        </h4>

        <div class="header-right">
          <!-- <div class="form-group mb-0" style="max-width: 200px; width: 100%">
            <input
              type="text"
              id="searchFilter"
              class="form-control"
              [(ngModel)]="searchFilter"
              placeholder="Search"
              (input)="onSearchFilterInput($event)"
            />
          </div> -->
          <a
            href="javascript: void(0);"
            class="btn btn-primary"
            placement="top"
            ngbTooltip="Add Membership"
            (click)="openModal(createModal, {}, 'Add Membership')"
          >
            + Add Membership
          </a>
        </div>
      </div>

      <div class="table-responsive" *ngIf="!loading">
        <table class="table table-striped border mt-4">
          <thead class="table-light">
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Total Price</th>
              <th scope="col">FreeProduct</th>
              <th scope="col">FreeShipment</th>
              <th scope="col">IsExclusive</th>
              <th scope="col">Timing</th>
              <th scope="col">Discount</th>
              <th scope="col">Duration</th>
              <th scope="col">Description</th>
              <th scope="col">Created At</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let membership of membershipList; let i = index">
              <td>
                <p placement="top" [ngbTooltip]="membership.name">
                  {{
                    membership.name
                      ? membership?.name?.length > 30
                        ? (membership.name | slice : 0 : 30) + "..."
                        : membership.name
                      : "-"
                  }}
                </p>
              </td>
              <td>
                <p placement="top">
                  {{ membership?.countryObject?.currency }}
                  {{ membership?.chargeableAmount / 100 }}
                </p>
              </td>

              <td>
                <p placement="top">
                  {{ membership?.freeProduct }}
                </p>
              </td>
              <td>
                <p placement="top">
                  {{ membership?.freeShipment ? "Yes" : "No" }}
                </p>
              </td>
              <td>
                <p
                  [ngClass]="{
                    badge: true,
                    'bg-success': membership?.isExclusive === true,
                    'bg-secondary': membership?.isExclusive === false
                  }"
                >
                  {{ membership?.isExclusive ? "Yes" : "No" }}
                </p>
              </td>

              <td>
                <p placement="top">
                  {{ membership?.timing | titlecase }}
                </p>
              </td>
              <td>
                <p placement="top">
                  {{ membership?.discount ? membership?.discount + "%" : 0 }}
                </p>
              </td>
              <td>
                <p placement="top">
                  {{ membership?.duration }}
                </p>
              </td>
              <td>
                <p placement="top">
                  {{ membership?.description }}
                </p>
              </td>
              <td>{{ membership.created_at | date : "short" }}</td>
              <td>
                <button
                  class="btn btn-sm btn-primary mr-1"
                  (click)="editMembership(membership._id)"
                  ngbTooltip="Edit Membership"
                >
                  <i class="fa fa-edit"></i>
                </button>
                <button
                  class="btn btn-sm btn-danger mr-1"
                  (click)="openDeleteModal(deleteModal, membership._id)"
                  ngbTooltip="Delete"
                >
                  <i class="fa fa-trash"></i>
                </button>

                <button
                  class="btn btn-sm btn-info"
                  (click)="openViewModal(viewModal, membership._id)"
                  ngbTooltip="View"
                >
                  <i class="fa fa-eye"></i>
                </button>
              </td>
            </tr>

            <tr *ngIf="LocationDetails?.length === 0 && !loading">
              <td colspan="8" class="text-center text-muted">
                No location records found.
              </td>
            </tr>
          </tbody>
        </table>

        <div
          class="d-flex justify-content-center mt-5"
          *ngIf="LocationDetails?.length != 0"
        >
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalCount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #createModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="editProductLabel">{{ modeltitle }}</h5>
    <button
      type="button"
      class="close"
      (click)="closeBtnClick()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <app-membership-form
      [membershipData]="detail"
      [isEditMode]="isEditMode"
      (membershipCreated)="onMembershipCreated($event)"
    >
    </app-membership-form>
  </div>
</ng-template>
<ng-template #deleteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="deleteModalLabel">Delete Location</h5>
    <button
      type="button"
      class="close"
      (click)="closeBtnClick()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">Are you sure you want to delete this membership?</div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="closeDeleteModalClick()"
    >
      Cancel
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
      Delete
    </button>
  </div>
</ng-template>
<ng-template #viewModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="fa fa-id-card me-2 text-primary"></i> Membership Details
    </h5>
    <button
      type="button"
      class="close"
      (click)="closeBtnClick()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="detail">
    <div class="card shadow-sm border-0">
      <div class="card-body p-0">
        <table class="table table-bordered table-striped mb-0">
          <tbody>
            <tr>
              <th scope="row" class="w-30">Name</th>
              <td>{{ detail?.name }}</td>
            </tr>
            <tr>
              <th scope="row">Total Price</th>
              <td>
                {{ detail.countryObject.currency }}
                {{ detail?.chargeableAmount / 100 }}
              </td>
            </tr>
            <tr></tr>
            <tr>
              <th scope="row">Free Product</th>
              <td>{{ detail?.freeProduct }}</td>
            </tr>
            <tr>
              <th scope="row">Free Shipment</th>
              <td>
                <span>
                  {{ detail?.freeshipment ? "Yes" : "No" }}
                </span>
              </td>
            </tr>
            <tr>
              <th scope="row">Exclusive</th>
              <td>
                <div
                  [ngClass]="{
                    badge: true,
                    'bg-success': detail?.isExclusive === true,
                    'bg-secondary': detail?.isExclusive === false
                  }"
                >
                  {{ detail?.isExclusive ? "Yes" : "No" }}
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">Timing</th>
              <td>{{ detail?.timing }}</td>
            </tr>
            <tr>
              <th scope="row">Discount</th>
              <td>{{ detail?.discount !== 0 ? detail?.discount + "%" : 0 }}</td>
            </tr>
            <tr>
              <th scope="row">Duration</th>
              <td>{{ detail?.duration }} Month(s)</td>
            </tr>
            <tr>
              <th scope="row">Description</th>
              <td>{{ detail?.description }}</td>
            </tr>
            <tr>
              <th scope="row">Created At</th>
              <td>{{ detail?.created_at | date : "medium" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
      Close
    </button>
  </div>
</ng-template>
